import Vue from "vue"
import VueRouter from "vue-router"

const routes = [
  {
    path: '/',
    name: "home",
    // redirect: 'organ-management'
    component: () => import("@/views/Index")
  },
  {
    path: '/user-config',
    name: 'user-config',
    component: () => import("@/components/layout")
  },
  {
    path: '/role',
    name: 'role',
    component: () => import("@/views/role-permissions")
  },
  {
    path: '/personal',
    name: 'personal',
    component: () => import("@/views/personal")
  },
  {
    path: '/organ-management',
    name: 'organ-management',
    component: () => import('@/views/organization-manage/index')
  }
  // { 
  //   path: prefix + "/about",
  //   name: "about",
  //   component: () => import("../views/About.vue")
  // }
]

let route = [];
if (window.__POWERED_BY_QIANKUN__) {
  console.log('我正在作为子应用运行');
  routes.forEach((item) => {
    console.log(item, this);
    // item.path = '/backstage/user-management' + item.path;
    route.push(item);
  });
} else route = routes;

// let router = new VueRouter({
//   mode: "hash",
//   route
// })

export default route;